export enum PageName {
  CHOOSE_SOLUTION = 'Choose solution',
  PAYMENT_TYPE = 'Choose payment type',
  YOUR_DETAILS = 'Your details',
  ORDER_SUMMARY = 'Order summary',
  PAY = 'Setup your account',
  PAY_ONLINE = 'Pay Online',
  PAY_STATUS = 'Pay status',
  ASSIGN_DEVICES = 'Assign Devices',
  CREATE_PROFILE = 'Create profile',
  CUSTOMER_DETAILS = 'Customer details',
  FICA = 'FICA',
}
